import type { AppClient } from '@pointfive/contracts';
import { client } from './DataProvider';

/** The typed application client (`@pointfive/contracts` AppClient) for model handlers: `api.execute.orders.market(...)`,
 *  `api.prepare.session.arm(...)`, … Phase 1 binds it to the in-process sim (DataProvider owns the one binding); Phase 2
 *  swaps that binding for tRPC over HTTP — handlers keep calling the same paths. Not wired into the model slices yet. */
export const api: AppClient = client;
export type { AppClient };
